import { hasLocalStorage } from "../../../js/utils/browser/browser";
import { STORAGE_KEYS } from "../../../js/constants";

class Stage {
  /**
   * @param {HTMLElement} element - Stage element
   */
  constructor(element) {
    this.element = element;
    this.hiddenClass = "is-hidden";
    this.placeholderEl = element.querySelector(".Stage-supporter");

    this._init();
  }

  /**
   * init
   */
  _init() {
    if (this.placeholderEl) {
      this._fillPlaceholder();
    }
  }

  /**
   * fills placeholder with name if there is a name saved in local storage
   *
   * @private
   */
  _fillPlaceholder() {
    if (hasLocalStorage()) {
      const name = window.localStorage.getItem(STORAGE_KEYS.SUPPORTER_NAME);

      if (name) {
        this.placeholderEl.textContent = name;
        this.placeholderEl.classList.remove(this.hiddenClass);
      }
    }
  }
}

export default Stage;
